var d = /* @__PURE__ */ ((o) => (o.CountryCode = "countryCode", o.RegionCode = "regionCode", o.Host = "host", o.Brand = "brand", o))(d || {});
export {
  d as KnownQueryKey
};
//# sourceMappingURL=index3.js.map
